// Packages
import React, { useEffect, useState } from 'react';
import { Navigate, useLocation, useNavigate, useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux'
// Actions 
import { removeRouterLink } from '../../../router/RouterActions';

/**
 * Private Route Component renders the route
 * only if the user is authorized to access the
 * application.
 * */
export default function PrivateRoute({ ...props }) {
    const dispatch = useDispatch();
    let location = useLocation();
    let params = useParams();
    let navigate = useNavigate();

    const [current, setCurrent] = useState(null);
    const [last, setLast] = useState('');

    const routerState = useSelector((state) => state.router);

    // Basic history tracking for middleware redirects using -1's to step back without knowing target url
    useEffect(() => {
        if( current === null) {
            setCurrent(location.pathname);
        }
        else if( location.pathname !== current ) {
            setLast(current);
            setCurrent(location.pathname);
        }
        // eslint-disable-next-line
    },[location])

    if (!props.authorized) {
        return <Navigate to="/login" state={{ from: location }} />;
    }

    // Remove router redirect url on page update
    if (location.pathname === routerState.link) {
        dispatch(removeRouterLink({}));
    }
    // Remove router redirect -1 on page update and matching last page 
    else if( routerState.link === -1 && last === location.pathname ) { 
        dispatch(removeRouterLink({}));
    }
    // Look for router redirect url or -1, redirect to url before render
    else if (routerState?.link ) {
        let link = routerState.link;
        if( routerState.link === -1 ) {
            link = last;
        }
        return <Navigate to={link} state={{ from: location }} />;
    }

    // Child props progation to pass hooks content to react class components 
    // Might be a better way to do this???
    const childrenWithProps = React.Children.map(props.children, child => {
        // Checking isValidElement is the safe way and avoids a typescript
        // error too.
        if (React.isValidElement(child)) {
            return React.cloneElement(child, { params, navigate });
        }
        return child;
    });

    return (
        <div>
            {childrenWithProps}
        </div>
    )
}